import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { configurationService } from "./appConfigService";
import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import { AuthProvider } from "./features/authentication/hooks/use-auth/AuthContext";
import { ThemeProvider } from '@mui/material';
import { brandThemeProvider } from "./shared/providers/BrandThemeProvider";
import { SnackbarProvider } from 'notistack';
import { CustomSnackbar } from "./screens/shared/views/CustomSnackbar";

configurationService.load().then(() => {
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    
    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <AuthProvider>
                    <ThemeProvider theme={brandThemeProvider.getTheme()}>
                        <SnackbarProvider
                            maxSnack={7}
                            autoHideDuration={10000}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            Components={{
                                success: CustomSnackbar,
                                error: CustomSnackbar,
                                warning: CustomSnackbar,
                                info: CustomSnackbar,
                            }}
                        >
                            <App />
                        </SnackbarProvider>
                    </ThemeProvider>
                </AuthProvider>
            </BrowserRouter>
        </React.StrictMode>
    ); 
});

reportWebVitals();